// extracted by mini-css-extract-plugin
export default {"wrapper":"PermissionsText_wrapper__wcbcV"};